// extracted by mini-css-extract-plugin
export var boldText = "_58-4";
export var checkboxContainer = "_58-6";
export var closeIcon = "_58-i";
export var container = "_58-0";
export var drawer = "_58-8";
export var drawerContent = "_58-9";
export var extraSmallText = "_58-5";
export var fulfillmentGroupTable = "_58-e";
export var largeText = "_58-3";
export var loadingSpinnerContainer = "_58-j";
export var mediumText = "_58-2";
export var narrow = "_58-f";
export var notificationLink = "_58-l";
export var packageCheckIconContainer = "_58-7";
export var slideoutHeaderActions = "_58-g";
export var slideoutHeaderActionsShifted = "_58-h";
export var slideoutHeaderContainer = "_58-a";
export var slideoutModal = "_58-c";
export var stickyHeaderWrapper = "_58-b";
export var table = "_58-k";
export var tableContainer = "_58-d";
export var tertiaryText = "_58-1";